import script from "./LoginTest.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginTest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__